module.exports = __webpack_public_path__ + "static/media/no.859a1356.svg";